import { useEffect, useState } from "react";
import { useAdminAuth } from "../../context/AdminAuthContext";

const AdminProfilePage = () => {
  const { admin, btnLoading, updateAdmin } = useAdminAuth();

  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    if (admin) {
      setForm({
        name: admin?.name || "",
        email: admin?.email || "",
        phone: admin?.phone || "",
      });

      setTimeout(() => {
        setLoading(false);
      }, 400);
    }
  }, [admin]);

  const updateField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleUpdate = async () => {
    const res = await updateAdmin(admin?._id, form);

    if (res.success) {
      setEditing(false);
    }
  };

  /* ───────── Skeleton Loader ───────── */
  if (loading) {
    return (
      <div className="p-6 animate-pulse">
        {" "}
        <div className="max-w-3xl mx-auto  bg-white border border-borderLight shadow-sm p-6">
          {" "}
          <div className="h-6 w-40 bg-divider mb-6"></div>
          <div className="space-y-4">
            <div className="h-10 bg-divider"></div>
            <div className="h-10 bg-divider"></div>
            <div className="h-10 bg-divider"></div>
          </div>
          <div className="mt-6 h-10 w-32 bg-divider"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      {" "}
      <div className="max-w-3xl mx-auto bg-surfaceColor border border-borderLight shadow-sm">
        {/* HEADER */}
        <div className="border-b border-divider px-6 py-4 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-headingText">
            Admin Profile
          </h2>

          {!editing && (
            <button
              onClick={() => setEditing(true)}
              className="px-4 py-2 bg-btnColor text-white text-sm hover:bg-btnHoverColor transition"
            >
              Edit
            </button>
          )}
        </div>

        {/* FORM */}
        <div className="p-6 space-y-5">
          {/* NAME */}
          <div>
            <label className="text-sm text-descriptionText block mb-1">
              Name
            </label>

            <input
              disabled={!editing}
              value={form.name}
              onChange={(e) => updateField("name", e.target.value)}
              className="w-full h-[44px] px-4 border border-borderLight outline-none focus:border-primaryAccent disabled:bg-gray-50"
            />
          </div>

          {/* EMAIL */}
          <div>
            <label className="text-sm text-descriptionText block mb-1">
              Email
            </label>

            <input
              disabled
              value={form.email}
              className="w-full h-[44px] px-4 border border-borderLight bg-gray-50 outline-none"
            />
          </div>

          {/* PHONE */}
          <div>
            <label className="text-sm text-descriptionText block mb-1">
              Phone Number
            </label>

            <input
              disabled={!editing}
              value={form.phone}
              maxLength={10}
              onChange={(e) => updateField("phone", e.target.value)}
              className="w-full h-[44px] px-4 border border-borderLight outline-none focus:border-primaryAccent disabled:bg-gray-50"
            />
          </div>

          {/* ACTION BUTTONS */}
          {editing && (
            <div className="flex gap-3 pt-4">
              <button
                onClick={handleUpdate}
                disabled={btnLoading}
                className="px-5 h-[42px] bg-btnColor text-white text-sm flex items-center gap-2 hover:bg-btnHoverColor transition"
              >
                {btnLoading && (
                  <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                Save Changes
              </button>

              <button
                onClick={() => {
                  setEditing(false);
                  setForm({
                    name: admin?.name || "",
                    email: admin?.email || "",
                    phone: admin?.phone || "",
                  });
                }}
                className="px-5 h-[42px] border border-borderLight text-sm hover:bg-divider transition"
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminProfilePage;
